import React, { useCallback, useState } from 'react'
import { NO_ITEMS } from 'redesign/shared/constants'
import MoreButton from '../more-button'
import ActionButton from './action-button'
import { ButtonContainer, BackgroundContainer, ActionButtonContainer } from './styles'
import type { ActionButtonsProps } from './types'

const ActionButtons: React.FC<ActionButtonsProps> = ({ mainActions = [], hiddenActions = [] }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [itemAnchorEl, setItemAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleButtonClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setItemAnchorEl(event.currentTarget)

      if (hiddenActions.length > 0) {
        setIsMenuOpen(true)
      }
    },
    [hiddenActions],
  )

  if (!mainActions.length && !hiddenActions.length) return null

  return (
    <BackgroundContainer>
      <ButtonContainer>
        <ActionButtonContainer>
          {mainActions.map((action, index) => (
            <ActionButton
              // Reason: we don't have a unique key for each action
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              {...action}
              onClick={(event) => {
                handleButtonClick(event)
                action.onClick && action.onClick(event)
              }}
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              anchorEl={itemAnchorEl}
            />
          ))}
        </ActionButtonContainer>
        {hiddenActions.length > NO_ITEMS && <MoreButton hiddenActions={hiddenActions} />}
      </ButtonContainer>
    </BackgroundContainer>
  )
}

export default ActionButtons
